// ProtectedRoute.js
import CircularProgress from '@mui/material/CircularProgress'
import { useAtomValue } from 'jotai'
import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { useUser } from '../components/hooks/useUsers'
import config from '../data/Config'
import { authUserAtom } from '../domains/auth/AuthSelectors'
import { isAuthenticatedAtom } from '../domains/auth/AuthSelectors'
import { currentUserAtom } from '../domains/user/AtomUsers'

// 要求：需登入 && 角色為指定的一種或多種，才給通過
const ProtectedRoute = ({ allowedRoles = [], allowAnonymous = false }) => {
  const authUser = useAtomValue(authUserAtom)
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const currentUser = useAtomValue(currentUserAtom)

  // useUsers will fetch if it is missing
  const { user } = useUser(authUser?.resourceId)

  const location = useLocation()

  // For Public Routes
  if (allowAnonymous) {
    if (isAuthenticated && !currentUser) {
      // Wait until current user is fetched
      return <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />
    }

    return <Outlet />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ redirectTo: location }} replace />
  }

  if (!user || !currentUser) {
    return <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />
  }

  if (config.IS_DEV) {
    // console.log('App is running in development mode, no route protection')
    return <Outlet />
  }

  const userRoles = user?.roles || []
  if (allowedRoles.length > 0 && !allowedRoles.some((role) => userRoles.includes(role))) {
    // 已登入，但角色不在允許列表裡，導向無權限提示
    return <Navigate to="/403" replace />
  }

  // 通過檢查，繼續渲染子頁面
  return <Outlet />
}

export default ProtectedRoute
